/**
 * Created by wangjun on 2019/6/16.
 */
import React,{Component} from 'react';
import {
    Scene,
    PerspectiveCamera,
    Color,
    HemisphereLight,
    WebGLRenderer,
    DirectionalLight,
    MeshPhongMaterial,
    AnimationMixer,
    Clock,
    Box3,
    LoopOnce,
    TextureLoader,
    DoubleSide,
    RepeatWrapping,
    Group,
    Matrix4, AnimationUtils
} from 'three';
import './Show-3D.scss';
import './progress-bar/progress-bar.scss';
import {FBXLoader} from '../common/es6-class';
import OrbitControls from 'three-orbitcontrols';
import {Event, defaultSelectors} from '../common/event';
import ProgressBar from './progress-bar/progress-bar';
import iconPlay from './paly.svg';
import iconContent from './content.svg';
import {isPC, server} from '../common/config';


export default class Show3D extends Component {

    constructor(props) {
        super(props);
        this.width = null;
        this.height = null;
        this.clock = new Clock();
        this.scene = null;
        this.camera = null;
        this.renderer = null;
        this.animateMixer = null;
        this.controls = null;
        this.geometries = null;
        this.openActive = null;
        this.firstIn = false;
        this.stack = {};
        this.state = {
            progress: null,
            loadProduct: null,
            openDescription: false
        };

    }

    componentDidMount() {
        this.container = document.getElementById('WebGL-output');
        this.width = this.container.clientWidth;
        this.height = this.container.clientHeight;
        this.init();
        this.transform();
    }

    init() {
        this.setState({progress:0});
        this.initScene();
        this.initBackground();
        this.initLight();
        this.initRenderer();
        this.animate();
        this.initListener();
        this.initCamera();
    }

    transform() {
        Event.on('SelectorChange',async (res)=>{
            if(res) {
                if(res.productId === this.state.loadProduct.id) {
                    this.replaceParts(res);
                    this.saveLatest(res);
                } 
            }
        });
        Event.on('WindowChange',async(data)=>{
            this.productChange(data);
        })
        Event.on('ProductChange', async(data)=>{
            this.productChange(data);
        });
    }

    productChange(data){
        if(this.geometries) {
            this.scene.remove(this.geometries);
            this.geometries = null;
        }
        this.stack = {};
        let state = {loadProduct: data};
        if(this.isGlass(data)) {
            //玻璃
            state.openDescription = false;
        }else if(this.isWindow(data)) {
            //窗花
            state.isWindow = true;
        }
        this.setState(state);
        if(data) {
            this.initModel(data);
        }
    }

    saveLatest(task) {
        switch(task.type) {
            case 1:
                this.stack.color1 = task;
                break;
            case 2:
                if(task.color) {
                    this.stack.color2 = task;
                }else{
                    this.stack.parts2 = task;
                }
                break;
            case 4:
                if(task.color) {
                    this.stack.color4 = task;
                }else{
                    this.stack.parts4 = task;
                }
            break;
        }
    }

    async replaceParts(res) {
        if(!this.geometries) {
            return;
        }
        let {type,color,color2,fbx,fbxPath,obj} = res;
        switch (type) {
            case 1:
                this.geometries.traverse((child)=>{
                    if (child.isMesh) {
                        if(child.name.indexOf('玻璃胶') > -1 && color2) {
                            let material = child.material.clone();
                            material.color = new Color(color2);
                            child.material = material;
                        }else if(child.name.indexOf('主色')> -1 || child.name.indexOf('窗花')> -1) {
                            let material = child.material.clone();
                            material.color = new Color(color);
                            child.material = material;
                        }
                    }
                });
                break;
            case 2:
                if(color){
                    this.geometries.traverse(async (child)=>{
                        if (child.isMesh) {
                            if(child.name.indexOf('把手')> -1) {
                                let material = child.material.clone();
                                material.color = new Color(color);
                                child.material = material;
                            }
                        }
                    })
                }else {
                   if(fbx) {
                       fbx.then((obj) => {
                           if (this.openActive.length > 1) {
                               this.geometries.traverse((c) => {//null
                                   if (c.name.indexOf('把手RootNode') > -1) {
                                       c.parent.remove(c);
                                   }
                               });
                           }
                           let target = '根配件';
                           let group = new Group;
                           obj.traverse((child) => {
                               if (child.name.indexOf(target) > -1) {
                                   this.geometries.traverse((c) => {//null
                                       if (c.name.indexOf(target) > -1) {
                                           group = child.clone();
                                           group.name = '把手RootNode';
                                           group.position.x = c.position.x;
                                           group.position.y = c.position.y;
                                           // todo
                                           group.position.z = c.position.z;
                                           c.parent.add(group);
                                       }
                                   });
                                   if (obj.animations.length > 0) {
                                       let clipAction = this.clipAnimation(obj.animations[0]);
                                       clipAction = this.animateMixer.clipAction(clipAction, group);
                                       if (this.openActive[0] && this.openActive[0].time > 0) {
                                           clipAction.clampWhenFinished = true;
                                           clipAction.setDuration(0.01);
                                           clipAction.loop = LoopOnce;
                                           clipAction.play();
                                       }
                                       this.openActive.push(clipAction);
                                   }
                                   ;
                               }
                           });

                           this.runStack('color2');
                           if (this.state.progress > 0 && this.state.progress < 100) {
                               this.setState({progress: 100});
                               this.progressFinished();
                           }
                       })
                   }else{
                       if(this.state.progress > 0 && this.state.progress < 100) {
                           this.setState({progress:100});
                           this.progressFinished();
                       }
                   }
                }
                break;
            case 4:
                let url;
                if(fbxPath && this.stack.color4) {
                    url = fbxPath.replace('{color}',this.stack.color4.id);
                }else if(color && this.stack.parts4){
                    url = this.stack.parts4.fbxPath.replace('{color}',res.id);
                }
                if(url) {
                    this.geometries.traverse((child)=>{
                        if (child.isMesh) {
                            if(child.name.indexOf('纱网')> -1) {
                                this.loaderTextures(url).then((texture)=>{
                                    texture.wrapS = texture.wrapT = RepeatWrapping;
                                    child.material = new MeshPhongMaterial({
                                        map: texture,
                                        transparent: true,
                                        opacity: 0.5,
                                        side: DoubleSide
                                    });
                                });

                            }
                        }
                    });
                }
                
                break;
        }
    }

    clipAnimation(animation) {
        let time = 75;
        if(this.state.loadProduct.id == 6) {
            time = 65;
        }
        if(this.state.loadProduct.id === 18) {
            time = 64;
        }
        if(this.state.loadProduct.id >= 26) {
            return animation;
        }
        return AnimationUtils.subclip(animation, 'kk', 0, time);
    }

    async loaderTextures(path) {
        let loader = new TextureLoader();
        let mesh = await new Promise((resolve)=>{
            loader.load(path,(g)=>resolve(g));
        });
        return mesh;
    }


    runStack(key) {
        this.stack[key] && this.replaceParts(this.stack[key]);
    }

    isGlass(product) {
        return product && (product.categoryId === 6);
    }

    hasWindow(product) {
        return product && (product.categoryId === 2);
    }

    isWindow(product) {
        return product && (product.id > 30) && (product.id <= 60);
    }

    toggle() {
        if(this.state.loadProduct && this.state.loadProduct.id == 30) {
            this.P30('toggleAnimation');
            return;
        }
        if(this.openActive[0].isRunning()) {
            return;
        }
        if(this.openActive[0].time == 0 || this.isGlass(this.state.loadProduct)) {
            this.openActive.forEach(active=>{
                active.stop();
                active.clampWhenFinished = true;
                active.setDuration(30);
                active.loop = LoopOnce;
                active.timeScale = 1;
                active.play();
            });
        }else{
            this.openActive.forEach(active=>{
                active.paused = false;
                active.startAt(8).play();
                active.timeScale = -1;
            });

        }
    }

    toggleWindow() {
        if(this.geometries) {
            this.geometries.traverse((child) => {
                if(child.isGroup) {
                    if(child.name.indexOf('窗花')> -1) {
                        child.visible = !child.visible;
                    }
                }
            });
        }
    }

    toggleDescription() {
        this.setState({openDescription: !this.state.openDescription});
    }

    initScene() {
        //scene
        this.scene = new Scene();
        // this.scene.background = new Color(0xe0eaf6);
        // this.scene.fog = new Fog(0xffffff, 400, 1500);
    }
    initBackground() {
    }

    initCamera() {
        let near,far,cameraz,camerax;
        //camera
        near = 0.1;
        far = 5000;
        if(this.state.loadProduct && this.state.loadProduct.id ==30) {
            near = 0.1;
            far = 30000;
            cameraz = -7500;
            camerax = 7500;
            let fov = 45;
            if(!isPC()) {
                fov = 60;
            }
            this.camera = new PerspectiveCamera(fov, this.width / this.height, near, far);
            this.camera.position.z = cameraz;
            this.camera.position.x = camerax;
            this.camera.updateProjectionMatrix();

        }else{
            near = 0.1;
            far = 5000;

            this.camera = new PerspectiveCamera(45, this.width / this.height, near, far);
            let vFOV = this.camera.fov * Math.PI / 180;
            let height = this.height * window.devicePixelRatio;
            this.defaultCameraZ = height / (2 * Math.tan(vFOV / 2));
            cameraz = this.defaultCameraZ + 1000;
            camerax = 0;
            this.camera.position.z = cameraz;
            this.camera.position.x = camerax;
            this.camera.updateProjectionMatrix();

        }

    }

    initControls() {
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        if(this.state.loadProduct && ( this.state.loadProduct.id == 30 || this.state.loadProduct.id == 29 )) {//
            this.controls.autoRotate = true;
            this.controls.enableZoom = false;
            this.controls.autoRotateSpeed = 0;
            this.controls.enableRotate = false;
        }else{
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            this.controls.autoRotate = true;
            this.controls.autoRotateSpeed = 0.5;
            this.controls.enableZoom = true;
            this.controls.maxDistance = this.defaultCameraZ + 800;
            this.controls.minDistance = Math.max(this.defaultCameraZ - 800,300);
        }
    }

    initLight() {
        //light
        let light = new HemisphereLight(0xffffff, 0x444444);
        this.scene.add(light);

        //
        let light2 = new DirectionalLight(0xffffff,1);
        light2.color.setHSL( 0.5, 1, 0.95 );
        light2.position.set(-400, 350 , 300);
        light2.castShadow = true;
        light2.shadow.camera.zoom = 4;
        this.light2 = light2;

        let light3 = new DirectionalLight(0xffffff,1);
        light3.color.setHSL( 0.5, 1, 0.95 );
        light3.position.set(400, 350 , -300);
        light3.castShadow = true;
        light3.shadow.camera.zoom = 4;
        this.light3 = light3;

        let light4 = new DirectionalLight(0xffffff,0.3);
        light4.position.set(-400, 0 , 300);
        light4.castShadow = true;
        light4.shadow.camera.zoom = 4;
        this.light4 = light4;

        let light5 = new DirectionalLight(0xffffff,0.3);
        light5.position.set(400, 0 , -300);
        light5.castShadow = true;
        light5.shadow.camera.zoom = 4;
        this.light5 = light5;

    }

    updateLight() {
        if(this.state.loadProduct.id == 30) {
            this.scene.remove(this.light2);
            this.scene.remove(this.light3);
            this.scene.add(this.light4);
            this.scene.add(this.light5);
        }else{
            this.scene.remove(this.light4);
            this.scene.remove(this.light5);
            this.scene.add(this.light2);
            this.scene.add(this.light3);
        }
    }

    initRenderer() {
        //renderer
        this.renderer = new WebGLRenderer({antialias: true,alpha: true,logarithmicDepthBuffer:true});
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.width, this.height);
        this.renderer.shadowMap.enabled = true;
        this.container.appendChild(this.renderer.domElement);
    }

    initListener() {
        window.addEventListener('resize',this.onWindowResize.bind(this),false);
    }

    onWindowResize() {
        this.width = this.container.clientWidth;
        this.height = this.container.clientHeight;
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.width,this.height);
    }

    P30(action,params) {
        if(!this.state.loadProduct || this.state.loadProduct.id != 30) {
            return;
        }
        switch(action) {
            case 'init' :
                let obj = params;
                this.product30Status = 0;
                this.product30Boli = [];

                let scale;
                if(isPC()) {
                    let vFOV = this.camera.fov * Math.PI / 180;
                    let height = (2 * Math.tan(vFOV / 2)) * 16000;
                    let width = height * this.camera.aspect;
                    scale = width / 11000;
                }else{
                    scale = 1;
                }
                obj.scale.set(scale,scale,scale);


                let box = new Box3().setFromObject(obj);
                let lenX = box.max.x - box.min.x;
                let lenY = box.max.y - box.min.y;
                let lenZ = box.max.z - box.min.z;

                //center
                let pointX = box.min.x + (lenX / 2);
                let pointY = box.min.y + (lenY / 2);
                let pointZ = box.min.z + (lenZ / 2);
                obj.position.set(0 - pointX, 0 - pointY , 0 - pointZ);

                obj.traverse((child)=>{
                    if (child.isMesh) {
                        if(child.name.indexOf('贴图')> -1) {
                            this.loaderTextures('/fbx/materials/textures/td.png')
                                .then((texture)=>{
                                    child.material = new MeshPhongMaterial({
                                        map: texture,
                                        side: DoubleSide
                                    });
                            });
                        }else if(child.name.indexOf('玻璃')> -1) {
                            child.material.transparent = true;
                            child.material.opacity = 0.98;
                            child.material.color= new Color('#f5fff9');
                            this.product30Boli.push(child);
                        }else if(child.name.indexOf('背景墙')> -1) {
                            child.material.color= new Color(0.6,0.6,0.55);
                        }else if(child.name.indexOf('窗框') > -1) {
                            child.material.color= new Color(0,0,0);
                        }else {
                            child.material.castShadow = false;
                        }
                    }
                });
                break;
            case 'animation' :
                if(this.product30Status == 1) {
                    if(this.product30Boli[0].material.opacity <= 0.05) {
                        this.product30Status = 2;
                    }else{
                        this.product30Boli[0].material.opacity -= 0.005;
                        this.product30Boli[1].material.opacity -= 0.005;
                    }
                }else if(this.product30Status == 3) {
                    if(this.product30Boli[0].material.opacity >= 0.98) {
                        this.product30Status = 0;
                    }else{
                        this.product30Boli[0].material.opacity += 0.005;
                        this.product30Boli[1].material.opacity += 0.005;
                    }
                }
                break;
            case 'toggleAnimation':
                if(this.product30Status == 0) {
                    this.product30Status = 1;
                }else{
                    this.product30Status = 3;
                }
                break;
        }
    }

    animate() {
        requestAnimationFrame(this.animate.bind(this));
        //通电玻璃动画
        this.P30('animation');

        //开关动画
        let delta = this.clock.getDelta();
        if (this.animateMixer) {
            this.animateMixer.update( delta );
        }
        //出场动画
        if(this.controls) {
            this.firstInAnimate();
        }
        if(this.scene && this.camera) {
            this.renderer.render(this.scene, this.camera);
        }
    }

    initModel(product) {
        let loader = new FBXLoader();
        let url = product.moduleUrl || product.fbxPath;
        if(!url) {
            return;
        }
        url = server+url;
        loader.load(url, (obj)=> {
            this.updateLight();
            if(this.geometries) {
                this.scene.remove(this.geometries);
                this.geometries = null;
            }
            if(this.state.loadProduct.id == 30){
                //特殊处理通电玻璃
                this.P30('init',obj);
            }else {
                switch(this.state.loadProduct.id) {
                    case 6:case 7:case 8:case 9:
                    case 10:case 11:case 12:case 14:
                    case 28:
                        let m = new Matrix4();
                        m.makeRotationY(Math.PI);
                        obj.matrix.multiplyMatrices(obj.matrix, m);
                        obj.matrix.decompose(obj.position, obj.quaternion, obj.scale);
                        break;
                    default:
                        break;
                }

                let box = new Box3().setFromObject(obj);
                let lenX = box.max.x - box.min.x;
                let lenY = box.max.y - box.min.y;
                let lenZ = box.max.z - box.min.z;

                //scale
                let scale;
                let ratio = window.devicePixelRatio;
                let w = this.width * ratio;
                let y = this.height * ratio;

                if((lenX / w) > (lenY / y) ) {
                    // X
                    scale = w * 0.7 / lenX;
                }else{
                    // y
                    scale = y * 0.7 / lenY;
                }
                if(this.state.loadProduct.id == 29) {
                    scale = scale * 3.2;
                }
                obj.scale.set(scale,scale,scale);

                let box2 = new Box3().setFromObject(obj);
                let lenX2 = box2.max.x - box2.min.x;
                let lenY2 = box2.max.y - box2.min.y;
                let lenZ2 = box2.max.z - box2.min.z;
                //center
                let pointX = box2.min.x + (lenX2 / 2);
                let pointY = box2.min.y + (lenY2 / 2);
                let pointZ = box2.min.z + (lenZ2 / 2);
                obj.position.set(0 - pointX, 0 - pointY , 0 - pointZ);

                //animation
                if(obj.animations && obj.animations.length > 0) {
                    this.animateMixer = new AnimationMixer(obj);
                    let clipAction = this.clipAnimation(obj.animations[0]);
                    clipAction = this.animateMixer.clipAction(clipAction);
                    this.openActive = [clipAction];
                }
                //特殊处理 玻璃 窗花 挖抽
                obj.traverse((child) => {
                    if (child.isMesh) {
                        if(child.name.indexOf('玻璃')> -1) {
                            child.material.transparent = true;
                            if(this.state.loadProduct.id > 25 && this.state.loadProduct.id < 29 ) {
                                child.material.opacity = 0.5;
                                child.material.color= new Color('#b9c5be');
                            }else if(this.state.loadProduct.id === 25){
                                child.material.opacity = 0.7;
                                child.material.color = new Color('#9da4a0');
                            }else{
                                child.material.opacity = 0.3;
                                child.material.color= new Color(0.3,0.3,0.3);
                            }

                        }
                    }
                    if(child.isGroup) {
                        if(child.name.indexOf('窗花')> -1) {
                            if(this.isWindow(this.state.loadProduct)) {
                                child.visible = true;
                            }else if(this.hasWindow(this.state.loadProduct)) {
                                child.visible = false;
                            }
                        }
                    }
                    if(this.state.loadProduct.id == 29) {
                        if (child.isMesh && child.name.indexOf('图片')> -1) {
                            this.loaderTextures('/fbx/materials/textures/td.png')
                                .then((texture) => {
                                    child.material = new MeshPhongMaterial({
                                        map: texture,
                                        side: DoubleSide
                                    });
                                });
                        }
                    }
                });
            };
            this.geometries = obj;
            this.scene.add(obj);

            //初始化配件把手
            if(this.state.loadProduct.moduleUrl) {
                this.runStack('color1');
                this.runStack('parts2');
                this.runStack('color2');
                this.runStack('parts4');
                this.runStack('color4');
                if(!this.stack.parts2) {
                    this.setState({progress:100});
                    this.progressFinished();
                }
            }else{
                this.setState({progress:100});
                this.progressFinished();
            }
        },(progress)=>{
            let total = 90;
            let p = Math.floor((progress.loaded / progress.total) * total);
            p = Math.max(this.state.progress,p);
            this.setState({progress:p});
        });
    }

    progressFinished() {
        setTimeout(()=>{
            this.setState({progress:null});
            //第一次加载动画初始化
            this.firstIn = true;
            this.initCamera();
            if(this.state.loadProduct.id != 29) {// && this.state.loadProduct.id != 30
                this.initControls();
            }

        },1000);
    }

    firstInAnimate() {
        if(this.firstIn) {
            if(this.state.loadProduct.id !== 30) {
                this.camera.position.z -= 50;
                if(this.camera.position.z <= this.defaultCameraZ) {
                    this.firstIn = false;
                }
            }

        }
    }

    render() {
        return (
          <div className="container">
              <div id="WebGL-output" className={this.state.loadProduct === false ? 'hide': null}>
              </div>
              <div className={(this.state.loadProduct === false || (this.isWindow(this.state.loadProduct))) ? 'hide': null}>
                  <div className={this.hasWindow(this.state.loadProduct) ? 'suspend-btn min' : 'suspend-btn'}>
                      <button onClick={this.toggle.bind(this)}>
                          <img src={iconPlay}></img><br></br>
                          <span>關閉/打開</span>
                      </button>
                      <button onClick={this.toggleDescription.bind(this)} className={this.isGlass(this.state.loadProduct) ? 'hidden': null}>
                          <img src={iconContent}></img><br></br>
                          <span>產品介紹</span>
                      </button>
                      <button onClick={this.toggleWindow.bind(this)} className={this.hasWindow(this.state.loadProduct) ? null : 'hidden'}>
                          <img src={iconContent}></img><br></br>
                          <span>窗花</span>
                      </button>
                  </div>
                  <div className={this.state.openDescription ? 'description': 'description hide'}>
                      <p>{this.state.loadProduct ? this.state.loadProduct.description : null}</p>
                  </div>
              </div>
              {this.loadProgressBar()}
              {this.loadErrorTip()}
          </div>
        );
    }
    loadProgressBar() {
        if(this.state.progress !=null && (this.state.progress >= 0 || this.state.progress <= 100)) {
            return(
              <div className="bar">
                <ProgressBar progress={this.state.progress}></ProgressBar>
              </div>
            );
        }
    }

    loadErrorTip() {
        if(this.state.loadProduct === false) {
            return(
                <div className="bar">
                    <p>產品暫未上傳模型，請選擇其他產品</p>
                </div>
            );
        }
    }
}